import React from "react";

const DicomDownloadPage = () => {

	const [sessionDownloads, setSessionDownloads] = React.useState([]);
	const [downloadManagerWorker, setDownloadManagerWorker] = React.useState(null);

	React.useEffect((e) => {
		setDownloadManagerWorker(!!window.SharedWorker ? new SharedWorker("/worklet/DownloadManagerWorker.js") : null);
	},[]);

	const downloadManagerWorkerCallBack = React.useCallback((e) => {
		let messageResult = e?.data;
		switch (messageResult?.type) {
			case 'list':
				for (let index = 0; index < messageResult.data?.length; index++) {
					const element = messageResult.data[index];
					if(element.obj){
						element.link = window.URL.createObjectURL(element?.obj);
					}
				}
				setSessionDownloads(messageResult.data);
				break;
			default:
				break;
		}
	}, [])

	React.useEffect(()=> {
		if(downloadManagerWorker){
			downloadManagerWorker.port.postMessage({ type: 'list' });
		}
	}, [downloadManagerWorker]);

	React.useEffect(()=> {
		if(downloadManagerWorker){
			downloadManagerWorker.port.onmessage = downloadManagerWorkerCallBack;
			//downloadManagerWorker.postMessage({ type: 'length'});
		}
	}, [downloadManagerWorker, downloadManagerWorkerCallBack]);

	return (
		<div>
			<h5>Download List</h5>
			<ul style={{ listStyle: 'none', padding: '0'}}>
				{ Array.isArray(sessionDownloads) && sessionDownloads?.map(item => {
					return <li style={{ position: 'relative'}}>
						<div style={{ color: 'black'}}>{ item.name}</div>
						<div style={{ position: 'relative', background: 'grey'}}>
							<div style={{ background: 'orange', height: '20px', width: '' + item.percent + '%'}}>
								
							</div>
							<div style={{ position: 'absolute', top: '0', color: 'white', width: '100%', textAlign: 'center' }}>
							{ item.percent === 0 && (
								<div>
									Waiting for server
									<div style={{ 
										animation: 'spinner-border 1000ms infinite linear', 
										width: 'fit-content' , 
										float: 'right',
										}}>
										<i className="zmdi zmdi-refresh" ></i>
									</div>
									</div>
								)}
							{ item.percent !== 100 && (
								<div>{ item.percent + '%'} - Sec: { item.seconds} - Kpbs: { item.kbps}</div>
								)}
								{ item?.link?.length > 0 && <a style={{ color: 'white' }} target="_blank" rel="noreferrer" download={item.name+'.zip'} href={item.link} onClick={(e) => {
										downloadManagerWorker?.port?.postMessage({ type: 'remove', data: { uri: item.uri }});
									}}>Download</a>}</div>
						</div>
						<i style={{ position: 'absolute', top: '0', right: '5px' }} className="zmdi zmdi-delete" onClick={(e) => {
							downloadManagerWorker?.port?.postMessage({ type: 'remove', data: { uri: item.uri }});
						}}></i>
					</li>;
				})}
			</ul>
		</div>
	);
};

export default DicomDownloadPage;
